import { Chips, UIHeading1, UIText1 } from '@cian/ui-kit';

import { type FC } from 'react';

import { LayoutBlock } from '../LayoutBlock';

import { type IPikHistoryItem } from './external/models/PikHistoryItem';

import styles from './PikHistory.css';

type PikHistory = {
  chipsOptions: IPikHistoryItem['chipsOption'][];
  activePikHistoryItem: IPikHistoryItem;
  onChange: (value: string[]) => void;
};

export const PikHistory: FC<PikHistory> = ({ chipsOptions, activePikHistoryItem, onChange }) => {
  return (
    <LayoutBlock id="pik-history" title="История компании">
      <div className={styles['container']}>
        <Chips<string>
          dataTestId="history-chips"
          options={chipsOptions}
          value={[activePikHistoryItem.chipsOption.value]}
          onChange={onChange}
        />
        <div className={styles['content']}>
          <span className={styles['title']} data-testid="history-title">
            {activePikHistoryItem.chipsOption.label}
          </span>
          <div className={styles['main-text-container']} data-testid="history-content">
            <UIHeading1 data-testid="history-content-title">{activePikHistoryItem.title}</UIHeading1>
            <UIText1 data-testid="history-content-description">{activePikHistoryItem.description}</UIText1>
          </div>
        </div>
      </div>
    </LayoutBlock>
  );
};
